<template>
  <div
    class="user-avatar-container"
    @click="$emit('click')"
    @mouseover="$emit('mouseover')"
    @mouseleave="$emit('mouseleave')"
  >
    <!-- 有头像图片 -->
    <img
      class="user-img"
      :src="avatar"
      v-if="avatar && avatar.length > 0"
      :style="{ borderRadius: `${this.radius ? 3 : 0}px` }"
    />
    <!-- 按规则生成头像 -->
    <div
      v-else
      :class="['font-avatar', `bg_color_${colorIndex}`]"
      :style="{
        fontSize: `${this.fontSize}px`,
        borderRadius: `${this.radius ? 3 : 0}px`
      }"
    >
      {{ simpleName }}
    </div>
  </div>
</template>
<script>
  import md5 from 'md5'
  export default {
    props: {
      username: {
        type: [String]
      },
      userId: {
        type: [String, Number]
      },
      avatar: {
        type: [String, Object]
      },
      radius: {
        type: Boolean,
        default() {
          return false
        }
      },
      fontSize: {
        type: Number,
        default() {
          return 12
        }
      }
    },
    data() {
      return {}
    },
    computed: {
      // 显示的简略名字
      simpleName() {
        if (!this.username) return ''
        let username = this.username.trim()
        let ret

        if (/[\uAC00-\uD7A3]/g.test(username)) {
          // 韩文
          if (username.length / 3 <= 2) {
            ret = username.substr(-1, 1)
          } else {
            ret = username.substr(-2, 2)
          }
        } else if (/[\u0800-\u4e00]/g.test(username)) {
          // 日文
          ret = username.substr(0, 1)
        } else if (/[\u4e00-\u9fa5]/g.test(username)) {
          // 中文
          ret = username.substr(0, 1)
        } else {
          // 英文
          if (username.indexOf(' ') != -1) {
            let ar_name = username.split(' ')
            ret = ar_name[0].substr(0, 1) + ar_name[ar_name.length - 1].substr(0, 1)
          } else {
            ret = username.substr(0, 2)
          }
        }
        return ret
      },
      // 头像背景色索引
      colorIndex() {
        try {
          // if (!this.userId) return 0;
          if (!this.userId && !this.username) return 0
          return md5((this.userId || this.username) + '').substr(0, 1)
        } catch (e) {
          console.log('e', e, this.userId, this.username)
          return 0
        }
      }
    },
    mounted() {},
    methods: {
      handleClick() {
        this.$emit('click')
      }
    }
  }
</script>
<style lang="scss" scoped src="./index.scss"></style>
